import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/common/shared/shared.module';
import { UserManagementComponent } from './user-management.component';
import { AddUserPopupComponent } from './add-user-popup/add-user-popup.component';

@NgModule({
  declarations: [
    UserManagementComponent,
    AddUserPopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule
  ],
  exports: [
    UserManagementComponent
  ]
})
export class UserManagementModule { }